import { get } from '../../utils/axios'

export const userRightOrgProfileAPI = async () => {
  return await get('right/org/profiles/user')
}
